import type { AppConfig, GalleryImage, GenerateRequest, GenerateResponse } from '../types/config'

const API_BASE = '/api'

export async function fetchConfig(): Promise<AppConfig> {
  const response = await fetch(`${API_BASE}/config`)
  if (!response.ok) {
    throw new Error('Failed to load configuration')
  }
  return response.json()
}

export async function fetchGallery(): Promise<GalleryImage[]> {
  const response = await fetch(`${API_BASE}/gallery`)
  if (!response.ok) {
    throw new Error('Failed to load gallery')
  }
  return response.json()
}

export async function generateIcon(request: GenerateRequest): Promise<GenerateResponse> {
  const response = await fetch(`${API_BASE}/generate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
  })
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Generation failed' }))
    throw new Error(error.message || 'Generation failed')
  }
  
  return response.json()
}

export function getAssetUrl(path: string, supabaseUrl: string, bucket: string): string {
  return `${supabaseUrl}/storage/v1/object/public/${bucket}/${path}`
}
